import React, { ReactNode } from "react";
import { Menu } from "@pushpress/shared-components";
import { useAppointments } from "../AppointmentsProvider/AppointmentsProvider";
import { AppointmentAction, AppointmentStatus } from "../Appointments.types";
import { appointmentActionsMap } from "../AppointmentsUtils";

interface AppointmentActionsMenuProps {
  userUuid: string;
  appointmentUuid: string;
  expiresAt?: string;
  status: AppointmentStatus;
  showFixedActions?: boolean; // remove together with appointments_recurring_booking_feature_flag
  onClose: VoidFunction;
  onSuccess: VoidFunction;
}

const AppointmentActionsMenu = (props: AppointmentActionsMenuProps) => {
  const {
    userUuid,
    appointmentUuid,
    expiresAt,
    status,
    showFixedActions,
    onClose,
    onSuccess,
  } = props;

  const {
    showCancelModal,
    showDeleteModal,
    showRescheduleModal,
    showChangeExpirationModal,
    showChangeStaffModal,
    checkInAppointment,
    noShowAppointment,
    showInfoModal,
  } = useAppointments();

  const menuMap: { [key in AppointmentAction]: ReactNode } = {
    info: (
      <Menu.Item
        key="info"
        label="More info"
        action={() => {
          showInfoModal(appointmentUuid);
          onClose();
        }}
      />
    ),
    delete: (
      <Menu.Item
        key="delete"
        label="Delete"
        action={() => {
          showDeleteModal(userUuid, appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
    changeExpiration: (
      <Menu.Item
        key="changeExpiration"
        label="Change expiration"
        action={() => {
          showChangeExpirationModal(userUuid, appointmentUuid, expiresAt, {
            onSuccess,
          });
          onClose();
        }}
      />
    ),
    checkIn: (
      <Menu.Item
        key="checkIn"
        label="Check in"
        action={async () => {
          await checkInAppointment(appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
    noShow: (
      <Menu.Item
        key="noShow"
        label="No show"
        action={async () => {
          await noShowAppointment(appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
    reschedule: (
      <Menu.Item
        key="reschedule"
        label="Reschedule"
        action={() => {
          showRescheduleModal(appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
    changeStaff: (
      <Menu.Item
        key="changeStaff"
        label="Change staff"
        action={() => {
          showChangeStaffModal(appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
    cancel: (
      <Menu.Item
        key="cancel"
        label="Cancel"
        action={() => {
          showCancelModal(appointmentUuid, { onSuccess });
          onClose();
        }}
      />
    ),
  };

  const actions: AppointmentAction[] = ["cancel", "reschedule", "changeStaff"];

  const menuItems = showFixedActions ? actions : appointmentActionsMap[status];

  return <Menu>{menuItems.map((name) => menuMap[name])}</Menu>;
};

export default AppointmentActionsMenu;
